(function () {
function $c3b10a83b523f372$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(arr);
}


function $09c9f293d010c0e1$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$79e617b1955a2616)(o, minLen);
}


function $227c6742e0ff6f82$export$1b5e630bc3aea29f(arr) {
    return (0, $c50969dc1df61e8b$export$7e0947b5ad3404e2)(arr) || (0, $09c9f293d010c0e1$export$1eb58a6e75231000)(arr) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr) || (0, $38c2d4931cb7a7c4$export$e6f3c4780d19eb2b)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $efec029548ccee7f$export$fdf2a89c76341bbf(arr, i) {
    return (0, $09cbfe85151ea6c6$export$e6256bf45c68d561)(arr) || (0, $8ca2848f896a6803$export$2fd15edff6687200)(arr, i) || (0, $d4f69c5c6c4654b1$export$a5be06335b3a083c)(arr, i) || (0, $a0bc1859061deae1$export$60dbc22abd7da546)();
}



"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$2996f80ef42b8419)(this, Game);
        // eslint-disable-next-line no-console
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.gameState = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
        });
        this.gameStatus = "idle";
        this.gameScore = 0;
        this.zeroCell = 16;
        this.number = [
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            4
        ];
    }
    (0, $4fc75ccb937ab1df$export$d60067ff2358eee8)(Game, [
        {
            key: "random",
            value: function random(max) {
                return Math.floor(Math.random() * (max + 1));
            }
        },
        {
            key: "addNewCell",
            value: function addNewCell() {
                var emptyCells = [];
                for(var i = 0; i < this.gameState.length; i++){
                    for(var j = 0; j < this.gameState[i].length; j++)if (this.gameState[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length > 0) {
                    var _emptyCells_this_random = (0, $efec029548ccee7f$export$fdf2a89c76341bbf)(emptyCells[this.random(emptyCells.length - 1)], 2), row = _emptyCells_this_random[0], cell = _emptyCells_this_random[1];
                    this.gameState[row][cell] = this.number[this.random(9)];
                    this.zeroCell--;
                }
            }
        },
        {
            key: "checkinitialState",
            value: function checkinitialState() {
                var count = 0;
                for(var i = 0; i < this.gameState.length; i++)for(var j = 0; j < this.gameState[i].length; j++){
                    if (this.gameState[i][j] === 0) count++;
                    else if (this.gameState[i][j] === 2048) this.gameStatus = "win";
                }
                this.zeroCell = count;
                if (count === 0 && !this.canMove()) this.gameStatus = "lose";
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var i = 0; i < this.gameState.length; i++)for(var j = 0; j < this.gameState[i].length; j++){
                    if (this.gameState[i][j] === 0) return true;
                    if (j < this.gameState[i].length - 1 && this.gameState[i][j] === this.gameState[i][j + 1]) return true;
                    if (i < this.gameState.length - 1 && this.gameState[i][j] === this.gameState[i + 1][j]) return true;
                }
                return false;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.gameState[i].filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < row.length - 1; j++)if (row[j] === row[j + 1]) {
                        row[j] *= 2;
                        row[j + 1] = 0;
                        score += row[j];
                    }
                    row = row.filter(function(num) {
                        return num !== 0;
                    });
                    while(row.length < 4)row.push(0);
                    arr.push(row);
                };
                if (this.gameStatus !== "playing") return;
                var arr = [];
                var score = 0;
                for(var i = 0; i < this.gameState.length; i++)_loop(i);
                if (JSON.stringify(arr) !== JSON.stringify(this.gameState)) {
                    this.gameState = arr;
                    this.addNewCell();
                    this.gameScore += score;
                    this.checkinitialState();
                }
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = _this.gameState[i].filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = row.length - 1; j > 0; j--)if (row[j] === row[j - 1]) {
                        row[j] *= 2;
                        row[j - 1] = 0;
                        score += row[j];
                    }
                    row = row.filter(function(num) {
                        return num !== 0;
                    });
                    while(row.length < 4)row.unshift(0);
                    arr.push(row);
                };
                if (this.gameStatus !== "playing") return;
                var arr = [];
                var score = 0;
                for(var i = 0; i < this.gameState.length; i++)_loop(i);
                if (JSON.stringify(arr) !== JSON.stringify(this.gameState)) {
                    this.gameState = arr;
                    this.addNewCell();
                    this.gameScore += score;
                    this.checkinitialState();
                }
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var column = [
                        _this.gameState[0][i],
                        _this.gameState[1][i],
                        _this.gameState[2][i],
                        _this.gameState[3][i]
                    ];
                    column = column.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < column.length - 1; j++)if (column[j] === column[j + 1]) {
                        column[j] *= 2;
                        column[j + 1] = 0;
                        score += column[j];
                    }
                    column = column.filter(function(num) {
                        return num !== 0;
                    });
                    while(column.length < 4)column.push(0);
                    for(var j1 = 0; j1 < _this.gameState.length; j1++)arr[j1][i] = column[j1];
                };
                if (this.gameStatus !== "playing") return;
                var arr = [
                    [],
                    [],
                    [],
                    []
                ];
                var score = 0;
                for(var i = 0; i < this.gameState.length; i++)_loop(i);
                if (JSON.stringify(arr) !== JSON.stringify(this.gameState)) {
                    this.gameState = arr;
                    this.addNewCell();
                    this.gameScore += score;
                    this.checkinitialState();
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var column = [
                        _this.gameState[0][i],
                        _this.gameState[1][i],
                        _this.gameState[2][i],
                        _this.gameState[3][i]
                    ];
                    column = column.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = column.length - 1; j > 0; j--)if (column[j] === column[j - 1]) {
                        column[j] *= 2;
                        column[j - 1] = 0;
                        score += column[j];
                    }
                    column = column.filter(function(num) {
                        return num !== 0;
                    });
                    while(column.length < 4)column.unshift(0);
                    for(var j1 = 0; j1 < _this.gameState.length; j1++)arr[j1][i] = column[j1];
                };
                if (this.gameStatus !== "playing") return;
                var arr = [
                    [],
                    [],
                    [],
                    []
                ];
                var score = 0;
                for(var i = 0; i < this.gameState.length; i++)_loop(i);
                if (JSON.stringify(arr) !== JSON.stringify(this.gameState)) {
                    this.gameState = arr;
                    this.addNewCell();
                    this.gameScore += score;
                    this.checkinitialState();
                }
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.gameScore;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.gameState;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.gameStatus;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.addNewCell();
                this.addNewCell();
                this.gameStatus = "playing";
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.gameState = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(row);
                });
                this.gameStatus = "idle";
                this.gameScore = 0;
                this.zeroCell = 16;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$fieldRow = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)(document.querySelectorAll(".field-row"));
var $197cd56b15c33885$var$scoreCeil = document.querySelector(".game-score");
var $197cd56b15c33885$var$startBtn = document.querySelector(".start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$addField = function() {
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        document.removeEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
        $197cd56b15c33885$var$game.gameStatus = "playing";
        return;
    }
    if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        document.removeEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
        $197cd56b15c33885$var$game.gameStatus = "playing";
        return;
    }
    for(var i = 0; i < $197cd56b15c33885$var$game.gameState.length; i++){
        var fieldCell = (0, $227c6742e0ff6f82$export$1b5e630bc3aea29f)($197cd56b15c33885$var$fieldRow[i].querySelectorAll(".field-cell"));
        for(var j = 0; j < $197cd56b15c33885$var$game.gameState[i].length; j++){
            var cell = fieldCell[j];
            var cellValue = $197cd56b15c33885$var$game.gameState[i][j];
            if (cellValue === 0 && cell.textContent > 0) {
                cell.classList.remove("field-cell--".concat(cell.textContent));
                cell.textContent = "";
            }
            if (cellValue > 0) {
                cell.classList.remove("field-cell--".concat(cell.textContent));
                cell.classList.add("field-cell--".concat(cellValue));
                cell.textContent = cellValue;
            }
        }
    }
    $197cd56b15c33885$var$scoreCeil.textContent = $197cd56b15c33885$var$game.gameScore;
};
var $197cd56b15c33885$var$handleKeyDown = function(e) {
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$addField();
};
var $197cd56b15c33885$var$handleStart = function() {
    document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
    if ($197cd56b15c33885$var$game.getStatus() === "playing") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
    }
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startBtn.classList.remove("start");
        $197cd56b15c33885$var$startBtn.classList.add("restart");
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
    }
    $197cd56b15c33885$var$addField();
};
$197cd56b15c33885$var$startBtn.addEventListener("click", $197cd56b15c33885$var$handleStart);

})();
//# sourceMappingURL=index.b2d67098.js.map
